import { Grid, Tab, Tabs } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import HomeWorkIcon from '@material-ui/icons/HomeWorkRounded';
import {
  addViewBusiness,
  getBusinessPartners,
  getInfosBusiness,
  getInfosDashboard,
  getMedias,
  getOffresEntreprise,
  getVitrineField,
} from '@webapps/business';
import {
  useAuth,
  useMutation,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import history from 'components/History';
import DisplayMedia from 'components/Media/Display/DisplayMedia';
import { useEffect, useState } from 'react';

import IncompleteVitrine from '../Dashboard/Components/IncompleteVitrine';
import Offer from './Components/Offer';
import Partner from './Components/partner';
import Presentation from './Components/presentation';
import ProfilName from './Components/profilName';

const VitrineBusiness = () => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const { params } = useRouter();
  const { id: idParam } = params;
  const { idUser, profile } = useAuth();
  const [incompleteVitrine, setIncompleteVitrine] = useState(false);

  const [page, setPage] = useState(1);
  const [pageMedias, setPageMedias] = useState(1);
  const [pagePartner, setPagePartner] = useState(1);

  const [scrollPartner, setScrollPartner] = useState(false);
  const [sizePartner, setSizePartner] = useState(window.innerWidth < 768 ? 40 : 40); // eliana la plus intelligente de Linkpick jsuis trop forte 
  const [scrollOffers, setScrollOffers] = useState(false);
  const [sizeOffers, setSizeOffers] = useState(window.innerWidth < 768 ? 3 : 6);
  const [scrollMedias, setScrollMedias] = useState(false);
  const [sizeMedias, setSizeMedias] = useState(window.innerWidth < 768 ? 3 : 4);


  const {
    data: { content: partners = [], totalElements: totalElements } = {},
    refetch: refetchPartner,
  } = useQuery(getBusinessPartners, {
    key: ['businessPartenersVitrine', pagePartner, idParam || idUser],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      type: 'accepted',
      page: pagePartner - 1,
      size: sizePartner,
    },
  });

  const {
    status: load,
    data: { content: offres = [], totalElements: totalElementsOffres } = {},
    isFetching,
    refetch: refetchOffers
  } = useQuery(getOffresEntreprise, {
    key: ['offres', page, idParam || idUser],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      page: page - 1,
      size: sizeOffers,
      status: 'opened',
    },
    keepPreviousData: true,
  });

  const { data: fieldVitrine = {} } = useQuery(getVitrineField, {
    key: 'businessFieldVitrine' + idParam || idUser,
    variables: { id: idParam ?? idUser },
  });

  const { data: infosVitrine = {} } = useQuery(getInfosBusiness, {
    key: 'businessInfosVitrine' + idParam || idUser,
    variables: { id: idParam ?? idUser },
  });

  const { data: dashboardInfo = {} } = useQuery(getInfosDashboard, {
    key: 'infoDashboardBusiness' + idParam || idUser,
    variables: { id: idParam ?? idUser },
  });

  const { data: { content: medias = [], totalElements: totalElementsMedias } = {} } = useQuery(getMedias, {
    key: ['medias', pageMedias + idParam || idUser],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      page: pageMedias - 1,
      size: sizeMedias,
    },
  });

  useEffect(() => {
    if (
      infosVitrine?.address?.label &&
      infosVitrine?.website &&
      infosVitrine?.phone &&
      infosVitrine?.sector?.label &&
      infosVitrine?.size?.min &&
      infosVitrine?.size?.max &&
      infosVitrine?.headOffice?.city &&
      infosVitrine?.headOffice?.cityCode &&
      infosVitrine?.foundationDate
    )
      setIncompleteVitrine(false);
    else setIncompleteVitrine(true);
  }, []);

  const { mutateAsync: mutateAddView } = useMutation(addViewBusiness);

  useEffect(() => {
    if (idParam) {
      mutateAddView({
        id: idParam,
      });
    }
  }, [idParam]);

  useEffect(() => {
    if (scrollPartner) {
      if (totalElements <= sizePartner) {
        return;
      }
      setSizePartner(sizePartner + 4);
      setTimeout(() => {
        setScrollPartner(false);
        refetchPartner();
      }, 200);
    }
    if (scrollOffers) {
      if (totalElementsOffres <= sizeOffers) {
        return;
      }
      setSizeOffers(sizeOffers + 6);
      setTimeout(() => {
        setScrollOffers(false);
        refetchOffers();
      }, 200);
    }
  }
    , [scrollPartner, scrollOffers]);

  return (
    <div className={classes.container}>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ columnGap: '25px', flexWrap: 'nowrap' }}
        className={css({
          '@media (max-width: 1100px)': {
            flexDirection: 'column',
            rowGap: '25px',
          },
        })}
      >
        {/* Partie gauche - 1/3 en lg */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={4}
          style={{ flexBasis: '33.33%', maxWidth: '33.33%' }}
          className={css({
            rowGap: '25px',
            width: '100%',
            '@media (max-width: 1100px)': {
              flexBasis: '100% !important',
              maxWidth: '100% !important',
            },
            '@media (max-width: 768px)': { rowGap: '20px' },
          })}
        >
          <Grid item xs={12}>
            <Grid
              container
              display="flex"
              alignItems="flex-start"
              style={{ columnGap: '25px' }}
            >
              <ProfilName
                city={infosVitrine?.address?.city}
                sector={infosVitrine?.sector?.label}
                location={infosVitrine?.address?.label}
                coverImage={dashboardInfo?.profile?.coverImageUrl}
                cp={infosVitrine?.address?.cityCode}
                name={infosVitrine?.name}
                owner={idUser === infosVitrine?.id}
                slogan={fieldVitrine?.data?.slogan}
                profileImage={dashboardInfo?.profile?.profileImageUrl}
                verified={dashboardInfo?.profile?.verified}
                website={infosVitrine?.website}
                facebook={infosVitrine?.facebook}
                twitter={infosVitrine?.twitter}
                instagram={infosVitrine?.instagram}
                pinterest={infosVitrine?.pinterest}
                linkedin={infosVitrine?.linkedin}
                tiktok={infosVitrine?.tiktok}
                youtube={infosVitrine?.youtube}
                phone={infosVitrine?.phone}
                email={infosVitrine?.email}
                partners={partners}
              />
              <Presentation
                email={infosVitrine?.email}
                foundationDate={infosVitrine?.foundationDate}
                headOffice={infosVitrine?.headOffice?.label}
                location={infosVitrine?.address?.label}
                phone={infosVitrine?.phone}
                presentation={dashboardInfo?.profile?.presentation}
                whattheyseek={fieldVitrine?.data?.whattheyseek}
                goodtoknow={fieldVitrine?.data?.goodtoknow}
                publicPrivee={infosVitrine?.organization}
                cp={infosVitrine?.address?.cityCode}
                city={infosVitrine?.address?.city}
                sector={infosVitrine?.sector?.label}
                sizeMax={infosVitrine?.size?.max}
                sizeMin={infosVitrine?.size?.min}
                specialization={infosVitrine?.specialization?.label}
                siret={infosVitrine?.siret}
                website={infosVitrine?.website}
                facebook={infosVitrine?.facebook}
                twitter={infosVitrine?.twitter}
                instagram={infosVitrine?.instagram}
                pinterest={infosVitrine?.pinterest}
                linkedin={infosVitrine?.linkedin}
                tiktok={infosVitrine?.tiktok}
                youtube={infosVitrine?.youtube}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Partie droite - 2/3 en lg */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={8}
          style={{ flexBasis: '66.67%', maxWidth: '66.67%' }}
          className={css({
            rowGap: '25px',
            '@media (max-width: 1100px)': {
              flexBasis: '100% !important',
              maxWidth: '100% !important',
            },
            '@media (max-width: 768px)': { rowGap: '20px' },
          })}
        >
          {medias.length > 0 && (
            <DisplayMedia
              medias={medias}
              imageInfo={dashboardInfo?.profile?.profileImageUrl}
              info={infosVitrine}
              size={sizeMedias}
              scrollMedias={scrollMedias}
              setScrollMedias={setScrollMedias}
              page={pageMedias}
              totalElements={totalElementsMedias}
              setPage={setPageMedias}
            />
          )}
          <Offer
            offers={offres}
            size={sizeOffers}
            scrollOffers={scrollOffers}
            setScrollOffers={setScrollOffers}
            totalElements={totalElementsOffres}
            load={load}
            isFetching={isFetching}
            page={page}
            setPage={setPage}
          />
          <Partner
            partners={partners}
            size={sizePartner}
            scrollPartner={scrollPartner}
            setScrollPartner={setScrollPartner}
            totalElements={totalElements}
            page={pagePartner}
            setPage={setPagePartner}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  scrollableContent: {
    height: 'calc(100vh - 75px - 68px)',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  container: {
    height: '100%',
        padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '100%',
    width: '100%',
    '@media (max-width:768px)': { padding: 0 },
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '10.000px',
    fontWeight: 600,
    '@media screen and (max-width: 768px)': {
      marginTop: 20,
    },
  },
});

export default VitrineBusiness;
